import { useState } from 'react';
import serviceimg from '../../../assets/images/SServices.png';
import treeimg from "../../../assets/images/Diagram2.png";
import PageHeader from '@/components/PageHeader';

// Import your tab content components
import USDMFPage from './USDMFPage';
import ASMFCEPPage from './ASMFCEPPage';
import CTDDMFPage from './CTDDMFPage';

function GlobalDrugMasterFileDMFClassification() {
  const [activeTab, setActiveTab] = useState("us-dmf");

  const tabs = [
    { id: "us-dmf", label: "US Drug Master File (DMF) Services" },
    { id: "asmf-cep", label: "ASMF & CEP Submission Services" },
    { id: "ctd-dmf", label: "CTD DMF Submission Services" },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "us-dmf":
        return <USDMFPage />;
      case "asmf-cep":
        return <ASMFCEPPage />;
      case "ctd-dmf":
        return <CTDDMFPage />;
      default:
        return null;
    }
  };

  return (
    <div className="font-sans">

      <PageHeader title='Our Services' imageUrl={serviceimg} breadcrumbs={['Home', 'Our Services', 'Regulatory Services', 'Global Drug Master File (DMF) Classification']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Regulatory Services
        </h2>

        <div className="flex items-center gap-2 mb-4 mt-12">
          <span className="w-4 h-4 rounded-full bg-sky-300  flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Global Drug Master File (DMF) Classification
          </h3>
        </div>
        <img src={treeimg} alt="Service" className="w-full h-auto my-6 rounded-md" />

        <h4 className="text-md font-bold text-[#05326D] mb-4">
          Navigating Regulatory Complexity with Clarity and Confidence
        </h4>

        <p className="mb-4 text-[#05326D]">
          Drug Master Files (DMFs) serve as critical regulatory documents that support the quality, safety, and efficacy of
          pharmaceutical substances and materials. Their structure and classification vary across international health
          authorities, each with distinct submission formats and content requirements. Understanding these frameworks is
          essential for successful global registration and compliance.
        </p>
        <p className="mb-8 text-[#05326D]">
          FDAC offers deep expertise in compiling, publishing, and managing DMFs tailored to the specific expectations of
          regulatory bodies worldwide. Below is a high-level overview of DMF classifications across key markets:
        </p>

        <hr className="border-t border-gray-300 mb-8" />

        <div className="flex items-center gap-2 mb-2">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-[16px] font-bold text-[#05326D]">
            United States (US FDA) – DMF Types
          </span>
        </div>

        <p className='text-[#05326D] mb-1'>
          United States (US FDA) DMF Types
        </p>

        <div className="flex items-center gap-2 mb-2">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-[16px] font-bold text-[#05326D]">
            European Union (EU-ASMF)
          </span>
        </div>

        <div className="ml-6 space-y-1">
          <p className="text-[15px] text-[#05326D]">
            <span className="font-semibold">-Applicant’s Part (AP): </span>Shared with the applicant
          </p>
          <p className="text-[15px] text-[#05326D]">
            <span className="font-semibold">- Restricted Part (RP):</span> Confidential information submitted directly to authorities
          </p>
        </div>

        <div className="flex items-center gap-2 mb-2">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-[16px] font-bold text-[#05326D]">
            EDQM-Certificate of Suitability (CEP)
          </span>
        </div>

        <div className="ml-6 space-y-1">
          <p className="text-[15px] text-[#05326D]">
            - Covers excipients and APIs that comply with European Pharmacopoeia standards
          </p>
          <p className="text-[15px] text-[#05326D]">
            - Supports streamlined EU submissions
          </p>
        </div>

        <div className="flex items-center gap-2 mb-2">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-[16px] font-bold text-[#05326D]">
            World Health Organization (WHO DMF)
          </span>
        </div>

        <div className="ml-6 space-y-1">
          <p className="text-[15px] text-[#05326D]">
            <span className="font-semibold">- Open Part: (AP): </span>Shared with the applicants
          </p>
          <p className="text-[15px] text-[#05326D]">
            <span className="font-semibold">- Restricted Part:</span> Confidential data submitted to WHO
          </p>
        </div>

        <div className="flex items-center gap-2 mb-2">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-[16px] font-bold text-[#05326D]">
            China DMF
          </span>
        </div>

        <div className="ml-6 space-y-1">
          <p className="text-[15px] text-[#05326D]">
            <span className="font-semibold">- Open Part: </span>For applicant reference
          </p>
          <p className="text-[15px] text-[#05326D]">
            <span className="font-semibold">- Restricted Part:</span> Submitted confidentially to Chinese authorities
          </p>
        </div>

        <div className="flex items-center gap-2 mb-2">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-[16px] font-bold text-[#05326D]">
            CTD DMF Format
          </span>
        </div>

        <div className="ml-6 space-y-1 mb-6">
          <p className="text-[15px] text-[#05326D]">
            <span className="font-semibold">- Closed Part: </span>Confidential technical documentation aligned with Common Technical Document (CTD) structure
          </p>
        </div>

        {/* Tab Buttons and Dynamic Page Content */}
        <div className="flex space-x-10 border-b border-gray-300 flex-shrink-0 mb-6">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`relative pb-2 font-semibold ${activeTab === tab.id ? 'text-[#05326D]' : 'text-[#05326D]'
                }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
              {activeTab === tab.id && (
                <span className="absolute left-0 -bottom-[2px] h-[3px] w-full bg-[#B5AB28]" />
              )}
            </button>
          ))}
        </div>

        {renderContent()}
      </div>
    </div>
  );
}

export default GlobalDrugMasterFileDMFClassification;
